import { useEffect, useState } from 'react';
import api from '../api/endpoints';
import { Button, Loading, Modal } from './Ui';

/**
 * The terms someone signs before their first sign-in, full height so they can
 * actually be read. A customer and a business sign different ones, so `role`
 * decides which is fetched; admin writes both in the panel.
 */
const TermsSheet = ({ open, role = 'user', onClose }) => {
  const [terms, setTerms] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!open) return;
    setFailed(false);
    api.settings.terms(role).then((r) => setTerms(r.data)).catch(() => setFailed(true));
  }, [open, role]);

  return (
    <Modal open={open} onClose={onClose} title={(terms && terms.title) || 'Terms & Conditions'} wide>
      {!terms && !failed ? <Loading /> : failed ? (
        <div className="t-body">Could not load the terms. Check your connection and try again.</div>
      ) : (
        <>
          <div
            className="t-body"
            style={{ whiteSpace: 'pre-wrap', lineHeight: 1.7, maxHeight: '65vh', overflowY: 'auto', paddingRight: 8 }}
          >
            {terms.content || 'The terms have not been published yet.'}
          </div>
          {terms.updatedAt ? (
            <div className="t-tiny" style={{ marginTop: 14 }}>
              Version {terms.version} · updated {new Date(terms.updatedAt).toLocaleDateString()}
            </div>
          ) : null}
        </>
      )}
      <div className="row" style={{ marginTop: 16 }}>
        <Button title="Close" variant="light" onClick={onClose} />
      </div>
    </Modal>
  );
};

export default TermsSheet;
